import { render, staticRenderFns } from "./tab-4.vue?vue&type=template&id=8f76ee8a"
import script from "./tab-4.vue?vue&type=script&lang=js"
export * from "./tab-4.vue?vue&type=script&lang=js"
import style0 from "./tab-4.vue?vue&type=style&index=0&id=8f76ee8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports